<div class="screen screen--gate">

  <header class="gate__head">
    <button class="gate__back" type="button" data-id="back" aria-label="<%= _lcs( 'Zurück' ) %>">
      <i class="icon icon--arrow-left"></i>
    </button>
  </header>

  <div class="gate__body">
    <span class="gate__icon"><i class="icon icon--<%= icon %>"></i></span>

    <h1 class="gate__title"><%= title %></h1>
    <p class="gate__text"><%= text %></p>

    <% if ( email ) { %>
    <p class="gate__mail"><i class="icon icon--mail"></i><span><%= email %></span></p>
    <% } %>

    <div class="gate__actions">
      <button class="btn btn--primary btn--lg btn--block" type="button" data-id="primary"><%= primaryLabel %></button>
      <button class="btn btn--secondary btn--lg btn--block" type="button" data-id="secondary"><%= secondaryLabel %></button>
    </div>

    <p class="gate__note"><%= note %></p>
  </div>

</div>
